import { List, ListItem } from '@fs/zion-ui'
import React from 'react'

export default function DeleteUserGroupsList({ memberSummaries }) {
  return (
    <List>
      {memberSummaries.map((memberSummary) => (
        <ListItem
          key={memberSummary.id}
          primaryText={memberSummary.name}
          endElement={<ListItem.MetaText text={memberSummary.id} />}
        />
      ))}
    </List>
  )
}
